import React from 'react'
import classnames from 'classnames'
import { useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { updateLoanBalances } from 'src/actions/home'
import { Button, Form, If, Text } from 'src/Components'
import { NumberedList } from 'src/Components/shared/List'
import LoanBalance from '../LoanBalance/LoanBalance'
import PropTypes from 'prop-types'
import DollarInput from 'src/Components/shared/Input/DollarInput'

import styles from './ShowPaidExtraPanel.module.scss'
import panelStyles from 'src/Components/shared/Panel/Panel.module.scss'

const propTypes = {
  loanDetails: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,
      id: PropTypes.string,
      date: PropTypes.string,
      termYears: PropTypes.num,
      termYearsEstimated: PropTypes.num,
      amount: PropTypes.num,
      principalLeft: PropTypes.num
    })
  ),
  loading: PropTypes.bool,
  onSubmit: PropTypes.func
}

const ShowPaidExtraPanel = ({ loanDetails, loading, onSubmit }) => {
  const dispatch = useDispatch()

  return (
    <Form
      className={panelStyles.container}
      fields={loanDetails.map(({ uuid, amount }) => ({
        name: uuid,
        conditions: [DollarInput.maxCondition(amount)],
        parse: DollarInput.parseValue
      }))}
      onSubmit={(e, formData) => {
        e.preventDefault()
        const changed = loanDetails.find(
          ({ uuid, principalLeft }) =>
            Math.round(principalLeft) !== formData[uuid]
        )
        if (changed) dispatch(updateLoanBalances(formData))
        onSubmit(changed)
      }}
    >
      <div className={classnames(panelStyles.headWrap, styles.infoWrapper)}>
        <div>
          <Text size='xl' align='center'>
            <FormattedMessage
              id='Homeowner.interest.paidExtra.headline'
              defaultMessage='What have you paid towards principal?'
            />
          </Text>
          <Text
            size='m'
            color='quiet'
            align='center'
            className={styles.secondHeader}
          >
            <FormattedMessage
              id='Homeowner.interest.paidExtra.subheadline'
              defaultMessage='We calculate all of your numbers based on loan details and today’s balance.'
            />
          </Text>
          <div className={styles.numberedListWrapper}>
            <If condition={loanDetails.length > 1}>
              <NumberedList
                render={LoanBalance}
                items={loanDetails}
                itemKey='uuid'
              />
            </If>
            <If condition={loanDetails.length === 1}>
              <div className={styles.singleLoan}>
                <LoanBalance {...loanDetails[0]} />
              </div>
            </If>
          </div>
        </div>
      </div>
      <div className={panelStyles.submitWrap}>
        <Button
          primary
          type='submit'
          fullWidth
          loading={loading}
          className={styles.saveButton}
        >
          <FormattedMessage
            id='Homeowner.interest.paidExtra.saveButton'
            defaultMessage='Save'
          />
        </Button>
      </div>
    </Form>
  )
}

ShowPaidExtraPanel.propTypes = propTypes

export default ShowPaidExtraPanel
